import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { TextField } from '@material-ui/core';

import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/ManagerManagement/messages';
import { translate } from 'containers/services/translate';
import Dialog from 'containers/AttributionManager/Dialogs/index';
import { StyleTitleDialog } from 'containers/AttributionManager/styles';
import { Autocomplete } from '@material-ui/lab';
import {
  formatExistingRoles,
  formatPayload,
  allowedRoles,
} from 'containers/ManagerManagement/utils';

export interface RoleManagementDialogProps {
  intl: IntlShape;
  open: boolean;
  handleClose: Function;
  requestSetPrivilegesManager: Function;
  selectedManager: any;
  requestGetManagersBawaba: Function;
}

export const RoleManagementDialog: React.FC<RoleManagementDialogProps> = (
  props,
): JSX.Element => {
  const [roles, setRoles] = useState([] as any);
  useEffect(() => {
    setRoles([
      ...formatExistingRoles(get(props.selectedManager, 'dataValues', {})),
    ]);
  }, [props.selectedManager]);

  const handleChangeAutoComplete = (
    event: React.ChangeEvent<{}>,
    value: any[],
  ) => {
    setRoles([...value] as any);
  };

  const handleSuccessCallback = () => {
    props.requestGetManagersBawaba();
    toast.success(translate(messages.toastManagerTitle, props));
    props.handleClose();
  };
  const handleValidate = () => {
    props.requestSetPrivilegesManager(
      {
        id: get(props.selectedManager, 'id'),
        ...formatPayload(roles, get(props.selectedManager, 'dataValues', {})),
      },
      handleSuccessCallback,
    );
  };
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      validateDialog={handleValidate}
      title={''}
      content={
        <Grid container direction="column">
          <Grid item style={{ marginBottom: '30px' }}>
            <span style={StyleTitleDialog}>
              {translate(messages.dialogTitle, props, {
                managerName: get(props.selectedManager, 'sagisName'),
              })}
            </span>
          </Grid>
          <Grid item>
            <Autocomplete
              className="lawyer-item"
              multiple
              id="roles"
              options={allowedRoles(roles)}
              getOptionLabel={(option: any) => `${option}`}
              value={roles}
              onChange={handleChangeAutoComplete}
              disabled={false}
              renderInput={params => (
                <TextField {...params} variant="standard" />
              )}
            />
          </Grid>
        </Grid>
      }
      disabled={false}
    />
  );
};

export default injectIntl(RoleManagementDialog);
